export enum DatepickerShortcuts {
    Last7Days = 'Last 7 Days',
    Last14Days = 'Last 14 Days',
    Last30Days = 'Last 30 Days',
    Last3Months = 'Last 3 Months',
    Last12Months = 'Last 12 Months',
    None = 'false',
}
